// extracted by mini-css-extract-plugin
export default {"tag":"BookingTag_tag__qgnBD"};